import React from 'react';
import { BuyPanel } from './BuyPanel';
import { PositionsPanel } from './PositionsPanel';
import { HeaderPanel } from './HeaderPanel';
import { isWithinUsMarketHours } from '../../shared/utils';

export const QuickTradingPage: React.FC = () => {

    return (
        <div className="page">
            {!isWithinUsMarketHours() && (
                <div className='message-box message-box--warning' style={{
                    width: '90%',
                    minWidth: '400px',
                    marginBottom: '10px'
                }}>
                    The Market is CLOSED.
                </div>
            )}

            <HeaderPanel />

            <BuyPanel />
            
            <PositionsPanel />
        </div>
    );
}